import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand animate-fadeInUp">
            <h3 className="gradient-text">La Soirée du Rire</h3>
            <p>Comedy Show Analytics Dashboard</p>
          </div>
          <div className="footer-links animate-slideInRight">
            <a href="#privacy" className="text-highlight">Privacy Policy</a>
            <a href="#terms" className="text-highlight">Terms of Service</a>
            <a href="#contact" className="text-highlight">Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 La Soirée du Rire. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
